import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const HiddenBadge = (props: BadgeProps): React.ReactElement => (
  <Badge
    {...props}
    icon={"EYE_OFF"}
    className={twMerge("bg-gray-100 text-black", props.className)}
  >
    Hidden
  </Badge>
);
